import { render, staticRenderFns } from "./outstockDetailDialogCust.vue?vue&type=template&id=3811c6a5&scoped=true&"
import script from "./outstockDetailDialogCust.vue?vue&type=script&lang=js&"
export * from "./outstockDetailDialogCust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3811c6a5",
  null
  
)

export default component.exports